import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


// Vuetify
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
  defaults: {
    VTextField: {
      color: '#32a69e'
    },
    VTextarea: {
      color: '#32a69e'
    },
    VBtn: {
      color:'black'
    }
  },
    theme: {
      defaultTheme: 'light',
      // defaultTheme: 'dark',
      themes: {
        
        light: {
          colors: {
            primary: '#152F59',
            secondary: '#32a69e',
          },
        },
      },
    },
    ssr: true,
    components,
    directives,
  })

createApp(App)
.use(store)
.use(router)
.use(vuetify)
.mount('#app')
